import {
  DeviceConnectionStatus,
  UnitStateV2,
} from '@eppendorf/vnls-device-service-utils';

import { ActivityStatus } from '$components/device/activity-status/activity-status';
import { ConnectionStatusBadge } from '$features/devices/connection-status-badge';

interface DeviceStatusProps {
  unitState?: UnitStateV2;
  connectionStatus?: DeviceConnectionStatus;
  bordered?: boolean;
}

export function DeviceStatus({
  unitState,
  connectionStatus,
  bordered = false,
}: DeviceStatusProps) {
  // always return "pending" for pending devices
  if (connectionStatus === 'waitingForMetadata') {
    return <ConnectionStatusBadge status={connectionStatus} bordered={bordered} />;
  }

  // always return "unavailable" for offline devices
  if (unitState === UnitStateV2.Offline) {
    return <ActivityStatus activityStatus={unitState ?? null} bordered={bordered} />;
  }

  // return "connected" in all other cases
  return <ConnectionStatusBadge status={connectionStatus} bordered={bordered} />;
}
